import { createSlice } from "@reduxjs/toolkit";

let initialState = {
  companyDetails: null
};

export const companyDetailsSlice = createSlice({
  name: "companydetails",
  initialState,
  reducers: {
    setcompanyDetails: (state, action) => {
      state.companyDetails = action.payload;
    }
  },
});

export const {
  setcompanyDetails
} = companyDetailsSlice.actions;

export default companyDetailsSlice.reducer;
